var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"ContactForm"}},[_c('v-layout',{attrs:{"wrap":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-form',{ref:"form"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }